// removed by extract-text-webpack-plugin
module.exports = {"grey":"#707070","paddingBottom":"_1GiB68A19dbgYoL5dMhD5a","svg":"_2UpeqGaZi3Pzoa46Yh0nGV","list":"_3nn-YeANp1B0qbqJL3JjQB","iconScale":"zaTy5tVUm3VkpFIPuW7Q1"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/foundations/Icons/IconsUsage/IconsUsage.css
// module id = 760
// module chunks = 0